namespace SP {
    export enum OrderType {
        Order = 1,
        InternalOrder = 2,
        LabelOnly = 3,
        POS = 4,
        CollectionAssembly = 5,
        CollectionDisassembly = 6
    }
}